import express, { Router } from 'express';
import type { MiddlewareContext } from '../types';
import { createOpenapiHandler } from './controller';
import { createOpenapiSpecHandler } from './spec-controller';

/**
 * Options for creating OpenAPI router
 */
export interface OpenapiRouterOptions {
  /** Path to the openapi.json file */
  openapiFilePath: string;
  /** Path to the OpenAPI spec source file for /openapi/spec; when omitted, the route is not registered */
  openapiSpecFilePath?: string;
  /** Enable source code enhancement */
  enableEnhancement: boolean;
  /** Server directory for source code scanning */
  serverDir?: string;
}

/**
 * Create OpenAPI router
 */
export function createOpenapiRouter(
  options: OpenapiRouterOptions,
  context: MiddlewareContext,
): Router {
  const { openapiFilePath, openapiSpecFilePath, enableEnhancement, serverDir } = options;
  const router = express.Router();
  const handler = createOpenapiHandler(openapiFilePath, enableEnhancement, serverDir);

  // GET /openapi.json - Serve enhanced OpenAPI specification with x-source
  router.get('/openapi.json', (req, res) => handler(req, res, context));

  // GET /openapi/spec - Serve filtered OpenAPI spec for /openapi/* with refs resolved
  if (openapiSpecFilePath) {
    const specHandler = createOpenapiSpecHandler(openapiSpecFilePath);
    router.get('/openapi/spec', (req, res) => specHandler(req, res, context));
  }

  return router;
}
